// extracted by mini-css-extract-plugin
export default {"cardBox":"App_cardBox__4skze","nowCard":"App_nowCard__otO+8","nextCard":"App_nextCard__ft50o","laterCard":"App_laterCard__cnVJ9","card":"App_card__1zT54"};